import type { IconProps } from './IconProps';

export const TelegramIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <g clipPath="url(#clip0_5386_1440)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM11.708 5.44067C11.588 6.70533 11.0667 9.77533 10.802 11.192C10.69 11.792 10.4687 11.9927 10.2553 12.012C9.79067 12.0547 9.438 11.7047 8.988 11.41C8.284 10.9487 7.886 10.6613 7.20267 10.2107C6.41267 9.69 6.92467 9.404 7.37467 8.93667C7.49267 8.814 9.53933 6.952 9.57933 6.78333C9.584 6.762 9.58933 6.68333 9.542 6.642C9.49467 6.60067 9.426 6.61467 9.37667 6.626C9.306 6.642 8.18133 7.38533 6.002 8.856C5.68267 9.07533 5.39333 9.182 5.134 9.17667C4.84867 9.17067 4.29933 9.01533 3.89067 8.882C3.39 8.71933 2.99133 8.63267 3.026 8.35667C3.044 8.21267 3.242 8.06533 3.62067 7.91467C5.95267 6.89867 7.508 6.22867 8.286 5.90467C10.508 4.98067 10.9693 4.82 11.2707 4.81467C11.648 4.80933 11.7387 5.12067 11.708 5.44067Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5386_1440">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
